import { ReactElement } from 'react';
import { getSchema } from '@localstack/services';
import { CreateEC2VPCRequest } from '@localstack/types';

import { MagicForm } from '../../magic/MagicForm';

export interface VPCFormProps {
  loading?: boolean;
  formId?: string;
  onSubmit: (data: CreateEC2VPCRequest) => unknown;
}

export const VPCForm = ({ loading, formId, onSubmit }: VPCFormProps): ReactElement => (
  <MagicForm
    schema={getSchema('EC2')}
    loading={loading}
    entry="CreateVpcRequest"
    formId={formId}
    fieldsOrder={[
      'CidrBlock',
      'InstanceTenancy',
      'AmazonProvidedIpv6CidrBlock',
      'Ipv6CidrBlock',
      'Ipv4IpamPoolId',
      'Ipv4NetmaskLength',
      'TagSpecifications',
    ]}
    fieldConditions={{
      '^DryRun$': false,
    }}
    onSubmit={(data: CreateEC2VPCRequest) => onSubmit(data)}
  />
);
